export const buildDataTable = (dataSource = [], columnTable = []) => {
    return {
        data: dataSource,
        fields: columnTable,
        header: columnTable.map((item) => item.title),
    };
};
